module.exports = __webpack_public_path__ + "static/RivieraNights-Regular-9d028421ac343217d5e9005225e42d75.woff2";